import React, { useState, useEffect } from "react";
import {
  Table,
  TableRow,
  TableBody,
  useTheme,
  Box,
  Typography,
  TableContainer,
} from "@mui/material";
import VantageListHead from "../../../../../component/ListHead/SignalList";
import {
  Tablecell,
  applySortFilter,
  getComparator,
} from "../../../../../component/Methods";
import {
  rebalancerTablePanelSx,
  getRebalancerScrollableTableContainerSx,
  getRebalancerLocatesTableRowSx,
  getRebalancerLocatesTableCellSx,
} from "../../../styles/rebalancerStyles";

const Rejected = ({ rejected, tableHeader }) => {
  const theme = useTheme();
  const [data, setData] = useState([]);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("ticker");

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    const filteredUsers = applySortFilter(
      rejected,
      getComparator(order, orderBy)
    );
    setData(filteredUsers);
  }, [order, orderBy, rejected]);

  return (
    <>
      <Box sx={rebalancerTablePanelSx}>
        <Typography sx={{ fontWeight: "bold", fontSize: "18px", mb: 1, flexShrink: 0 }}>
          Rejected Locates
        </Typography>

        <TableContainer sx={getRebalancerScrollableTableContainerSx(theme)}>
          <Table
            size="small"
            stickyHeader
            aria-label="a dense table"
            sx={{
              height: "max-content",
            }}
          >
            <VantageListHead
              order={order}
              orderBy={orderBy}
              headLabel={tableHeader}
              noStatus={true}
              customizeFont={12}
              rowCount={data.length}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {data?.map((row, index) => (
                <TableRow key={index} sx={getRebalancerLocatesTableRowSx(theme)}>
                  <Tablecell align="left" sx={getRebalancerLocatesTableCellSx(theme, "left")}>
                    {row?.ticker?.toUpperCase() || ""}
                  </Tablecell>
                  <Tablecell align="right" sx={getRebalancerLocatesTableCellSx(theme, "right")}>
                    {row?.shareCount}
                  </Tablecell>
                  <Tablecell align="left" sx={getRebalancerLocatesTableCellSx(theme, "left")}>
                    {row?.fund}
                  </Tablecell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </>
  );
};

export default Rejected;
